import React, { useState } from 'react';
import axios from 'axios';

const BookingForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        phoneNumber: '',
        date: '',
        time: '',
        instagramId: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('https://0bxp6ujxrd.execute-api.us-east-1.amazonaws.com/dev/book', formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            alert('Booking successful: ' + response.data);
        } catch (error) {
            alert('Failed to book slot: ' + error.response?.data?.message || 'Unknown error');
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Name" required onChange={handleChange} />
            <input type="text" name="phoneNumber" placeholder="Phone Number" required onChange={handleChange} />
            <input type="date" name="date" required onChange={handleChange} />
            <input type="time" name="time" required onChange={handleChange} />
            <input type="text" name="instagramId" placeholder="Instagram ID (optional)" onChange={handleChange} />
            <button type="submit">Book Slot</button>
        </form>
    );
};

export default BookingForm;
